import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import HeaderPublic from '../../components/headerPublic/index.js'
import Footer from '../../components/footer/index.js'
import Faq from '../../components/faq/index.js';

import './styles.css'



const Help = () => {

    const accordion = [
        {
            "title": "Como acessar a plataforma coedados sendo colaborador Natura?",
            "body": "Para acessar a plataforma coedados basta preencher na página de login o seu e-mail corporativo e sua senha de rede."
        },
        {
            "title": "Como acessar a plataforma coedados sendo colaborador Avon, The Body Shop e Aesop?",
            "body": RegisterUserPortal()
        },
        {
            "title": "Como resolver erros comuns ao tentar logar no portal?",
            "body": CommonPortalErrors()
        },
        {
            "title": "Como alterar sua senha do portal (Exclusivo para colaboradores Avon, The Body Shop e Aesop)?",
            "body": ResetPasswordPortal()
        },
        {
            "title": "Como solicitar a mudança de perfil do meu usuário na plataforma coedados?",
            "body": "Encaminhe um e-mail para data_aa_engenharia@natura.net com o título: PORTAL COEDADOS - ACESSOS. Incluir o e-mail que deseja mudar o perfil assim como o perfil desejado (engenheiro de dados|cientista de dados|governança de dados). Lembrando que será realizada uma análise antes de conceder o acesso solicitado."
        },
        {
            "title": "Precisa de suporte, relatar erros ou fornecer sugestões e/ou feedbacks?",
            "body": "Encaminhe um e-mail para data_aa_engenharia@natura.net com o título: PORTAL COEDADOS - SUPORTE|ERROS|SUGESTÕES|FEEDBACKS."
        }
    ]

    return (
        <div className='help-container'>
            <HeaderPublic />

            <Faq accordion={accordion} />

            <Footer />
        </div>
    );
}


const CommonPortalErrors = () => (
    <div>
        <div>
            <p><b>- Usuário não ativo:</b></p>
            <p className='help-recuo'>
                Verique sua caixa de e-mail, inclusive o spam, e procure pelo título <b>Finalizar Cadastro</b> enviado por <b>no-reply@{process.env.REACT_APP_ENVIRONMENT}.naturacloud.com</b>
                , siga as orientações do e-mail pra finalizar seu cadastro.
            </p>
            <p className='help-recuo'>
                Esse processo é exclusivo para colaboradores Avon, The Body Shop e Aesop.
            </p>
            <br/>
            <p><b>- Usuário não cadastrado:</b></p>
            <p className='help-recuo'>
                Siga as etapas em <b>Como acessar a plataforma coedados sendo colaborador Avon, The Body Shop e Aesop?</b>
            </p>
            <br/>
            <p><b>- Usuário sem permissão:</b></p>
            <p className='help-recuo'>
                O portal coedados é exclusivo para colaboradores Natura, Avon, The Body Shop e Aesop.
            </p>
            <p className='help-recuo'>
                Caso seja de uma dessas empresas, <b>verifique se seu e-mail foi digitado corretamente</b>. 
                Validado o e-mail e o erro ainda persiste, entre em contato com data_aa_engenharia@natura.net
                relatando brevemente seu problema.
            </p>
        </div>
    </div>
)


const RegisterUserPortal = () => {
    const link = "https://portal.natura-coedados-"+ process.env.REACT_APP_ENVIRONMENT + ".naturacloud.com/cadastro-novo-usuario"

    return (
    <div>
        <div>
            <p className='help-recuo'>
                Para acessar a plataforma coedados será necessário realizar um cadastro prévio na plataforma, isso pode ser feito <a href={link}>clicando aqui</a>.
            </p>
            <br/>
            <p className='help-recuo'>
                Após cadastrar-se no link acima, você receberá um e-mail com instruções para criar sua senha de acesso e complementar seu cadastro.
            </p>
        </div>
    </div>
)}


const ResetPasswordPortal = () => {
    const link = "https://portal.natura-coedados-"+ process.env.REACT_APP_ENVIRONMENT + ".naturacloud.com/cadastro-nova-senha"
    
    return (
    <div>
        <div>
            <p className='help-recuo'>
                Para alterar sua senha <a href={link}>clique aqui</a>
            </p>
            <br/>
            <p className='help-recuo'>
                Após cadastrar-se no link acima, você receberá um e-mail com instruções para criar sua senha de acesso e complementar seu cadastro.
            </p>
        </div>
    </div>
)}


export default Help;
